import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Upload() {
  const navigate = useNavigate();
  const [supplier, setSupplier] = useState('');
  const [date, setDate] = useState('');
  const [fileName, setFileName] = useState('');

  const handleFile = (e) => {
    if (e.target.files[0]) setFileName(e.target.files[0].name);
  };

  const handleUpload = () => {
    setTimeout(() => navigate('/history'), 800);
  };

  return (
    <div className="content">
      <div className="card mx-auto" style={{ maxWidth: 540 }}>
        <div className="ch">
          <div className="ch-ico">⬆</div>
          <div>
            <div className="ch-title">Upload Supplier List</div>
            <div className="ch-sub">Nova parses, normalises and flags ambiguities for review</div>
          </div>
        </div>
        <div className="cb">
          {/* Drop zone */}
          <label className="d-block text-center p-4 rounded-3 mb-3 position-relative" style={{ border: '2px dashed var(--brd)', cursor: 'pointer', transition: 'all .18s' }}>
            <input type="file" accept=".xlsx,.csv,.pdf" onChange={handleFile} className="position-absolute top-0 start-0 w-100 h-100 opacity-0" style={{ cursor: 'pointer' }} />
            <div style={{ fontSize: 40, marginBottom: 10 }}>📁</div>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 5 }}>
              {fileName || 'Drop supplier list here'}
            </div>
            <div style={{ fontSize: 12, color: 'var(--t3)', marginBottom: 14 }}>
              Excel (.xlsx) · CSV · PDF<br />Nova reads, normalises fields, detects molecule types
            </div>
            <span className="btn btn-p btn-sm">Choose File</span>
          </label>

          {/* Form */}
          <div className="mb-3">
            <label className="flabel">Supplier Name</label>
            <input className="finput" placeholder="e.g. Pharmasupply GmbH" value={supplier} onChange={e => setSupplier(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="flabel">List Date</label>
            <input className="finput" type="date" value={date} onChange={e => setDate(e.target.value)} />
          </div>
          <div className="d-flex gap-2">
            <button className="btn btn-s flex-grow-1" onClick={() => navigate('/history')}>Cancel</button>
            <button className="btn btn-p flex-grow-1" onClick={handleUpload}>Upload &amp; Parse</button>
          </div>
        </div>
      </div>
    </div>
  );
}
